import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { SmartShell } from '../../components/smart/SmartShell';
import { formatCurrency } from '../../components/smart/utils/format';
import { SMART_ROUTES } from '../../constants';
import { smartMockCompose, smartMockQuote } from '../../gallery/smartMock';

/**
 * Gallery committing spinner. Auto-advances to SendDone after a short delay
 * so the screen stays inspectable in the Control Dock.
 */
export const CommittingPage = () => {
  const { t } = useTranslation('smart');
  const navigate = useNavigate();
  const amountLabel = formatCurrency(
    smartMockQuote.receiveAmount,
    smartMockQuote.receiveCurrency,
  );
  const intentKey =
    smartMockCompose.intent === 'send' || smartMockCompose.intent === 'pay'
      ? smartMockCompose.intent
      : 'request';

  useEffect(() => {
    const id = window.setTimeout(() => {
      navigate(SMART_ROUTES.DONE_SEND);
    }, 2200);
    return () => window.clearTimeout(id);
  }, [navigate]);

  return (
    <SmartShell hideHeader>
      <section className="flex flex-col items-center justify-center gap-6 py-16 text-center">
        <motion.span
          aria-hidden
          className="border-accent inline-block h-12 w-12 rounded-full border-4 border-t-transparent"
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 1, ease: 'linear' }}
        />
        <div className="flex flex-col gap-2">
          <h2 className="text-2xl font-semibold tracking-tight">
            {t(`wizard.committing.${intentKey}.title`)}
          </h2>
          <span className="text-accent text-3xl font-bold tracking-tight">
            {amountLabel}
          </span>
          <p className="text-fg-muted mt-1 max-w-xs text-sm">
            {t(`wizard.committing.${intentKey}.subtitle`)}
          </p>
        </div>
      </section>
    </SmartShell>
  );
};
